export const formatearNumeroAR = (valor) =>
  (Number(valor) || 0).toLocaleString('es-AR', { maximumFractionDigits: 2 })
